export function getFeedUrlForPath(path = '', title = '') {
    const titleMatch = path.match('^(?!/program$|/kanaler$|/genre$)(\\/[\\w-]+)(\\?.+)?$');
    const genreMatch = path.match('^(\\/genre\\/[\\w-]+)(\\?.+)?$');

    if (path === '/') {
        return [
            {
                path: '',
                title: '',
            },
        ];
    } else if (titleMatch !== null) {
        return [
            {
                path: titleMatch[1],
                title: title ? 'Senaste avsnitten av ' + title : '',
            },
        ];
    } else if (genreMatch !== null) {
        return [
            {
                path: genreMatch[1],
                title: title ? 'Senaste avsnitten från SVT inom ämnet ' + title : '',
            },
            {
                path: genreMatch[1] + '/klipp',
                title: title ? 'Senaste klippen från SVT inom ämnet ' + title : '',
            },
        ];
    }

    return [];
}
